import { createContext } from "react";
import { InboxTagsProviderState } from "./InboxTagsProvider.types";

export const InboxTagsProviderContext = createContext<InboxTagsProviderState | undefined>(undefined);